#import "src/queries/fragments/personFragment.graphql"
#import "src/queries/fragments/personMemberOf.graphql"

fragment IndividualAllocationFragment on IndividualAllocation {
  allocationProjectId
  allocationId
  targetGroupId
  targetGroup {
    id
    name
    parentIds
    type
    isHidden
    hierarchyIds
    hierarchy
  }
  personId
  fte
  existingFte
  status
}

query getIndividualAllocations(
  $allocationProjectId: String!
  $personId: String!
) {
  individualAllocations: getIndividualAllocations(
    allocationProjectId: $allocationProjectId
    personId: $personId
    status: ["allocated", "preallocated"]
  ) {
    ...IndividualAllocationFragment
  }
}

query getIndividualAllocationsForGroup(
  $groupId: String!
  $allocationProjectId: String!
) {
  individualAllocations: getIndividualAllocationsForGroup(
    allocationProjectId: $allocationProjectId
    groupIds: [$groupId]
    queryType: ALLOCATIONS_FOR_MEMBERS_CURRENTLY_WITHIN_GROUP
    includeIndirect: true
  ) {
    ...IndividualAllocationFragment
    person {
      ...PersonFragment
    }
  }
}

#-------- MUTATIONS --------

mutation allocateIndividualAllocation(
  $allocationId: String!
  $allocationProjectId: String!
  $targetGroupId: String!
  $personId: String!
  $requestedFte: Float
) {
  individualAllocations: allocateIndividualAllocation(
    allocationId: $allocationId
    allocationProjectId: $allocationProjectId
    targetGroupId: $targetGroupId
    personId: $personId
    requestedFte: $requestedFte
  ) {
    ...IndividualAllocationFragment
  }
}

mutation unallocateIndividualAllocation(
  $allocationId: String!
  $allocationProjectId: String!
  $targetGroupId: String!
  $personId: String!
) {
  individualAllocations: unallocateIndividualAllocation(
    allocationId: $allocationId
    allocationProjectId: $allocationProjectId
    targetGroupId: $targetGroupId
    personId: $personId
  ) {
    ...IndividualAllocationFragment
  }
}

mutation updateFteIndividualAllocation(
  $allocationId: String!
  $allocationProjectId: String!
  $targetGroupId: String!
  $personId: String!
  $requestedFte: Float!
) {
  individualAllocations: updateFteIndividualAllocation(
    allocationId: $allocationId
    allocationProjectId: $allocationProjectId
    targetGroupId: $targetGroupId
    personId: $personId
    requestedFte: $requestedFte
  ) {
    ...IndividualAllocationFragment
  }
}

mutation markGroupAsHidden($id: String!, $isHidden: Boolean) {
  team: markGroupAsHidden(id: $id, isHidden: $isHidden) {
    id
    isHidden
  }
}

mutation cloneHierarchy($input: CloneHierarchyInput!) {
  cloneHierarchy(input: $input) {
    id
    jobId
    jobName
  }
}

mutation fulfillVacantRole($input: FulfillVacantRoleInput!) {
  individualAllocations: fulfillVacantRole(input: $input) {
    ...IndividualAllocationFragment
  }
}

query reloadAllocatedPersonAndGroups(
  $personId: String!
  $directGroupIds: [String]
  $fteSumInput: FteSumInput!
) {
  directGroups: getGroups(groupIds: $directGroupIds) {
    id
    memberCount
    directMemberCount
    fteSum(input: $fteSumInput)
    members(limit: 500) {
      ...PersonFragment
    }
  }
  person: getPerson(aggregateId: $personId) {
    ...PersonMemberOfFragment
  }
}

query reloadGroupDetails($groupId: String!, $fteSumInput: FteSumInput!) {
  result: getGroup(groupId: $groupId) {
    id
    memberCount
    directMemberCount
    fteSum(input: $fteSumInput)
    members(limit: 500) {
      ...PersonFragment
      isPlaceholder
      isVacancy
      isAIAgent
    }
  }
}
